import React from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export function WhyItWorks() {
  const points = ['productos personalizados', 'accesorios artesanales', 'diseños únicos', 'calidad premium'];
  return <section className="py-10 px-4 bg-white" data-id="element-308">
      <div className="max-w-4xl mx-auto" data-id="element-309">
        <div className="flex flex-col md:flex-row items-center gap-6 bg-brand-50 rounded-2xl p-5 md:p-7 border border-brand-100 shadow-sm" data-id="element-310">
          <div className="flex-1" data-id="element-311">
            <div className="inline-flex items-center gap-2 bg-brand-200 text-brand-800 px-3 py-1 rounded-full font-bold text-xs mb-3" data-id="element-312">
              <TrendingUpIcon fontSize="small" data-id="element-313" /> ALTA DEMANDA
            </div>
            <h2 className="text-2xl font-bold text-slate-900 mb-3 leading-tight" data-id="element-314">
              🐾 ¿POR QUÉ ESTE NEGOCIO FUNCIONA TAN BIEN?
            </h2>
            <p className="text-base text-slate-700 mb-3 font-medium" data-id="element-315">
              Porque el mercado de mascotas no deja de crecer. Y cada vez más
              personas buscan:
            </p>
            <ul className="space-y-1.5 mb-4" data-id="element-316">
              {points.map((point, idx) => <li key={idx} className="flex items-center gap-3 text-slate-800 font-semibold" data-id="element-317">
                  <CheckCircleIcon className="text-brand-500" data-id="element-318" />
                  <span data-id="element-319">{point}</span>
                </li>)}
            </ul>
            <div className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm" data-id="element-320">
              <p className="text-slate-600 mb-1 text-sm" data-id="element-321">
                Mientras la mayoría sigue vendiendo productos genéricos…
              </p>
              <p className="font-bold text-brand-700" data-id="element-322">
                Vos podés diferenciarte con algo artesanal y emocional.
              </p>
            </div>
          </div>

          <div className="hidden md:flex flex-1 justify-center" data-id="element-323">
            <div className="text-8xl" data-id="element-324">🐕</div>
          </div>
        </div>
      </div>
    </section>;
}